import React, { useContext } from "react";
import styles from "./index.module.scss";
import AsideLink from "./components/AsideLink";
import classNames from "classnames";
import CoursewareContext from "../../store";
import { isTrue } from "Utils/filter";

interface AsideProps {
    visible: boolean;
    onToggle?: () => void;
}

export default function Aside({ visible, onToggle }: AsideProps) {
    const { current, list, onSelect } = useContext(CoursewareContext);

    return (
        <div className={classNames(styles.root, { [styles.hidden]: !visible })}>
            <div className={styles.inner}>
                <div className={styles.header}>目录</div>

                <div className={styles.main}>
                    {list.map((item, index) => (
                        <AsideLink
                            key={item.id}
                            active={item.id === current}
                            onClick={() => onSelect(item.id)}
                            filename={item.sourceFileEntity?.fileName || ""}
                            fileType={item.sourceFileEntity?.fileType || ""}
                            desc={item.sourceFileEntity?.description || ""}
                            finished={isTrue(
                                item.studyStatusEntity?.studyStatus
                            )}
                        />
                    ))}
                </div>
            </div>

            <button className={styles.toggleBtn} onClick={onToggle} />
            <div role="button" className={styles.mask} onClick={onToggle} />
        </div>
    );
}
